import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {getCurrentInstance, onBeforeUnmount, onMounted} from "vue";


const __default__ = {
    name: "SizeObserverWrapper"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["width", "height"],
  setup(__props, { emit: __emit }) {

let emits = __emit

let resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(entry => {
        emits("width", entry.contentRect.width);
        emits("height", entry.contentRect.height);
    });
});


let instance = getCurrentInstance();
onMounted(() => {
    resizeObserver.observe(instance.proxy.$el);
});

onBeforeUnmount(() => {
    resizeObserver.disconnect();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})